export default "__VITE_ASSET__DVh9_ap5__"